import GenerateIndicesButton from "./script.js";

function AdminPage() {
  return (
    <div>
      <h1>Admin Tools</h1>
      <GenerateIndicesButton />
    </div>
  );
}

export default AdminPage;
// This is a simple admin page that includes a button to generate indices.